export default __webpack_public_path__ + "static/media/user_placehoder_avatar@2x.96cc6412.png";